"use client";

import { formatCurrencyAmount, getBtcUnit } from "@workspace/currency";
import {
  CurrencyIcon,
  cn,
  normaliseCurrencyCode,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import type { LabeledCurrencyItem } from "./getCurrencyDropdownData";

type Props = {
  item: LabeledCurrencyItem;
  isActive: boolean;
  isUbtcEnabled: boolean;
  onSelect: (item: LabeledCurrencyItem) => void;
};

const CurrencyDropdownItem: FC<Props> = ({
  item,
  isActive,
  isUbtcEnabled,
  onSelect,
}) => {
  const isBtc = item.currency === "BTC";
  const { value, code } = formatCurrencyAmount({
    amount: item.cashierBalance,
    currency: item.currency,
    type: item.type,
    maximumFractionDigits: item.maximumFractionDigits,
    unit: isBtc ? getBtcUnit(isUbtcEnabled) : undefined,
  });

  return (
    <button
      type="button"
      onClick={() => onSelect(item)}
      className={cn(
        "flex w-full cursor-pointer items-center justify-between gap-2 rounded-xl border-2 border-transparent bg-accent p-2 hover:bg-accent/70",
        isActive && "border-[var(--primary)]",
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-4">
        <CurrencyIcon currency={item.currency} />
        <span className="truncate text-sm font-medium text-foreground">
          {item.label} ({normaliseCurrencyCode(item.currency)})
        </span>
      </div>
      <span className="flex shrink-0 items-center gap-1 text-sm tabular-nums text-foreground">
        {value}
        {isBtc && (
          <span className="text-xs font-medium text-muted-foreground">
            {code}
          </span>
        )}
      </span>
    </button>
  );
};

export default CurrencyDropdownItem;
